import { Popup } from "devextreme-react";
import { useState } from "react";
import { CreateEditApp } from "../../../../Components/CreateEditApp";
import { useSelector } from "react-redux";
import { Delete } from "../../../../Components/Delete";
import logomain from "../../../../images/logo-main.png";

const EditAppPopup = ({
  setcraeteAppShow,
  craeteAppShow,
  viewData,
  setDAta,
}) => {
  return (
    <>
      <Popup
        visible={craeteAppShow}
        onHiding={() => {
          setcraeteAppShow(false);
        }}
        showTitle={false}
        width={455}
        height={619}
        showCloseButton={true}
        hideOnOutsideClick={true}
      >
        <CreateEditApp
          craeteAppShow={craeteAppShow}
          setcraeteAppShow={setcraeteAppShow}
          type={1}
          viewData={viewData}
          setDAta={setDAta}
        />
      </Popup>
    </>
  );
};

const DeletePopup = ({ setDeleteShow, DeleteShow, viewData }) => {
  return (
    <>
      <Popup
        visible={DeleteShow}
        onHiding={() => {
          setDeleteShow(false);
        }}
        showTitle={false}
        width={455}
        height={280}
        showCloseButton={true}
        hideOnOutsideClick={true}
      >
        <Delete
          setDeleteShow={setDeleteShow}
          DeleteShow={DeleteShow}
          viewData={viewData}
        />
      </Popup>
    </>
  );
};

export const AppInformation = ({ subTab, data, setDAta }) => {
  const [EditAppShow, setEditAppShow] = useState(false);
  const [DEleteShow, setDEleteShow] = useState(false);
  const { viewData } = useSelector((store) => store.dashboard);

  return (
    <>
      <EditAppPopup
        setcraeteAppShow={setEditAppShow}
        craeteAppShow={EditAppShow}
        viewData={viewData}
        setDAta={setDAta}
      />

      <DeletePopup
        setDeleteShow={setDEleteShow}
        DeleteShow={DEleteShow}
        viewData={viewData}
      />

      <div id="tab1" className={`tab-content ${subTab === 1 && `current`}`}>
        <div className="commonCard">
          <div className="appInformation">
            <div className="appInformation__head">
              <h1 className="title">App Settings</h1>
              <div className="btnActions">
                <button
                  onClick={() => {
                    setEditAppShow(true);
                  }}
                  className="btn btn--grayOutline"
                >
                  <svg
                    className="btn__icon"
                    width={19}
                    height={18}
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.4375 14.1047V17.75H4.21302L15.3483 6.99871L11.5728 3.35339L0.4375 14.1047ZM18.268 4.17966C18.6607 3.80055 18.6607 3.18813 18.268 2.80902L15.9121 0.534335C15.5194 0.155221 14.8851 0.155221 14.4925 0.534335L12.65 2.31326L16.4256 5.95858L18.268 4.17966Z"
                      fill="#989898"
                    />
                  </svg>
                </button>
                <button
                  onClick={() => {
                    setDEleteShow(true);
                  }}
                  className="btn btn--redOutline"
                >
                  Delete App
                </button>
              </div>
            </div>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="appInformation__body"
            >
              <div style={{ width: "45%" }}>
                <div className="form__group">
                  <label className="form__label">App Name</label>
                  <div
                    style={{
                      border: "1px solid #0475d7",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={data?.app_name ? data?.app_name : viewData?.app_name}
                    className="form__input"
                  >
                    <p style={{ color: "black" }}>
                      {data?.app_name ? data?.app_name : viewData?.app_name}
                    </p>
                  </div>
                </div>
                <div className="form__group">
                  <label className="form__label">App Logo</label>
                  <div className="aapLogo">
                    <img
                      className="aapLogo__img"
                      style={{
                        objectFit: "cover",
                        height: "80px",
                        width: "80px",
                      }}
                      alt="app logo"
                      src={
                        data?.app_logo
                          ? data?.app_logo
                          : viewData?.app_logo
                          ? viewData?.app_logo
                          : logomain
                      }
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "45%",
                }}
              >
                <div className="form__group">
                  <label className="form__label">Webhook URL</label>
                  <div
                    className="form__input"
                    style={{ border: "1px solid #0475d7" }}
                    title={
                      data?.privay_policy_url
                        ? data?.privay_policy_url
                        : viewData?.privay_policy_url
                    }
                  >
                    <p
                      style={{
                        color: "blue",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textDecorationLine: "underline",
                      }}
                      onClick={() => {
                        window.open(
                          data?.privay_policy_url
                            ? data?.privay_policy_url
                            : viewData?.privay_policy_url,
                          "_blank"
                        );
                      }}
                    >
                      {data?.privay_policy_url
                        ? data?.privay_policy_url
                        : viewData?.privay_policy_url}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
